import * as React from 'react';
import { UIHeading4, UIText2, Spinner } from '@cian/ui-kit';

import { EPaymentStatus, TPaymentStatus } from '../../../../../../types/reducers/depositAccount';

import packageImgSrc from './assets/package.png';
import * as styles from './RecommendedPackagesPaymentStatus.css';

interface IProps {
  status: TPaymentStatus;
  handleRetryClick(): void;
}

export const RecommendedPackagesPaymentStatus = ({ status, handleRetryClick }: IProps) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['content']}>
        <img className={styles['icon']} width={32} height={32} src={packageImgSrc} />

        <div>
          <UIHeading4>Покупаем пакет</UIHeading4>

          <UIText2>Сможете его использовать, как только пройдет оплата</UIText2>
        </div>
      </div>

      {status === EPaymentStatus.Pending && <Spinner size={20} />}

      {status === EPaymentStatus.Fail && (
        <div className={styles['link']} onClick={handleRetryClick}>
          Проверить ещё раз
        </div>
      )}
    </div>
  );
};
